"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkTextColourChanger = void 0;
var react_1 = __importDefault(require("react"));
var lodash_1 = require("lodash");
var inversify_react_1 = require("inversify-react");
var mobx_1 = require("mobx");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Utils_1 = require("./Utils");
var FontColourPicker_1 = require("./FontColourPicker");
var BulkTextColourChanger = function (_a) {
    var configsAndStyles = _a.configsAndStyles;
    var blockStore = (0, inversify_react_1.useInjection)("blockStore");
    var blockStyleStore = blockStore.blockStyleStore;
    var widgetColourGroups = buildWidgetColourGroups(configsAndStyles);
    function onBulkColourUpdate(styleKeys, newColour) {
        (0, mobx_1.runInAction)(function () {
            var e_1, _a;
            var _b;
            try {
                for (var styleKeys_1 = __values(styleKeys), styleKeys_1_1 = styleKeys_1.next(); !styleKeys_1_1.done; styleKeys_1_1 = styleKeys_1.next()) {
                    var styleKey = styleKeys_1_1.value;
                    var blockStyle = (_b = blockStyleStore.getElementStyle(styleKey)) !== null && _b !== void 0 ? _b : {};
                    var nextStyle = __assign(__assign({}, (0, lodash_1.cloneDeep)(blockStyle)), { color: newColour });
                    blockStyleStore.setElementStyle(styleKey, nextStyle);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (styleKeys_1_1 && !styleKeys_1_1.done && (_a = styleKeys_1.return)) _a.call(styleKeys_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        });
    }
    return (react_1.default.createElement(kaleidoscope_1.Stack, { paddingLeft: "l", paddingRight: "l", paddingTop: "m", paddingBottom: "m", gap: "xs" },
        react_1.default.createElement(kaleidoscope_1.Label, { long: true }, "Text colors"),
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal" }, widgetColourGroups.map(function (_a) {
            var colorObject = _a.colorObject, widgets = _a.widgets;
            var tooltipContent = widgets.map(function (_a) {
                var displayName = _a.displayName;
                return displayName;
            }).join(", ");
            var key = widgets.map(function (_a) {
                var styleKey = _a.styleKey;
                return styleKey;
            }).join("-");
            return (react_1.default.createElement(FontColourPicker_1.FontColourPicker, { key: key, currentColour: colorObject, tooltipContent: tooltipContent, onColorChange: function (newColour) {
                    onBulkColourUpdate(widgets.map(function (_a) {
                        var styleKey = _a.styleKey;
                        return styleKey;
                    }), newColour);
                } }));
        }))));
};
exports.BulkTextColourChanger = BulkTextColourChanger;
function buildWidgetColourGroups(configsAndStyles) {
    var e_2, _a;
    var coloursToWidgetsMap = new Map();
    try {
        for (var configsAndStyles_1 = __values(configsAndStyles), configsAndStyles_1_1 = configsAndStyles_1.next(); !configsAndStyles_1_1.done; configsAndStyles_1_1 = configsAndStyles_1.next()) {
            var _b = configsAndStyles_1_1.value, style = _b.style, _c = _b.styleableConfig, styleKey = _c.styleKey, properties = _c.properties, displayName = _b.widgetConfig.displayName;
            var colorObject = (0, Utils_1.getFontColourPropertyAndValue)(style, properties).value;
            var groupByKey = "".concat(colorObject.abs, "_").concat(colorObject.themeIndex == null ? "" : colorObject.themeIndex);
            var currentWidgetInfo = { styleKey: styleKey, displayName: displayName !== null && displayName !== void 0 ? displayName : "" };
            var existingEntry = coloursToWidgetsMap.get(groupByKey);
            if (existingEntry) {
                existingEntry.widgets.push(currentWidgetInfo);
            }
            else {
                coloursToWidgetsMap.set(groupByKey, {
                    colorObject: colorObject,
                    widgets: [currentWidgetInfo],
                });
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (configsAndStyles_1_1 && !configsAndStyles_1_1.done && (_a = configsAndStyles_1.return)) _a.call(configsAndStyles_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return Array.from(coloursToWidgetsMap.values());
}
